import React, { useCallback } from "react";

import makeStyles from "@mui/styles/makeStyles";
import ListItem from "@mui/material/ListItem";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import ListItemText from "@mui/material/ListItemText";

import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";

import Typography from "@mui/material/Typography";
import { visuallyHidden } from "@mui/utils";
import { green, red, yellow, grey } from "@mui/material/colors";
import Tooltip from "@mui/material/Tooltip";
import Grid from "@mui/material/Grid";
import { Box } from "@mui/material";

const useStyles = makeStyles(theme => ({
  itemContent: {
    height: "auto",
    fontSize: "1.25rem",
    borderBottom: "solid",
    borderBottomColor: grey[200],
    backgroundColor: "white",
  },

  listItemText: {
    textTransform: "none",
  },

  contentTitle: {
    fontSize: "2.00rem",
    fontWeight: "bold",
    marginBottom: theme.spacing(4),
  },

  labelAndValue: {
    "& label": {
      fontWeight: "bold",
      paddingRight: theme.spacing(2),
    },
  },

  active: {
    textTransform: "uppercase",
    color: green[500],
  },

  inactive: {
    textTransform: "uppercase",
    color: red[500],
  },

  restricted: {
    textTransform: "uppercase",
    color: yellow[500],
  },

  actionContainer: {
    "& button": {
      margin: "10px 0",
    },
  },
}));

const KeystoreListItem = ({ keystore, selected, onDeleteClick, onSelect }) => {
  const classes = useStyles();

  const handleDeleteClicked = useCallback(() => {
    onSelect(keystore);
    onDeleteClick(keystore);
  }, [onSelect, onDeleteClick, keystore]);

  return (
    <ListItem
      selected={selected}
      classes={{ root: classes.itemContent }}
      key={keystore.accessKey}
      onClick={() => onSelect(keystore)}
    >
      <ListItemText
        classes={{ root: classes.listItemText }}
        disableTypography={true}
        primary={
          <Box mb={2}>
            <Grid container spacing={1} direction="column">
              <Grid item sm={12}>
                <Box className={classes.labelAndValue}>
                  <label>Access Key:</label>
                  {keystore.accessKey}
                </Box>
              </Grid>
              <Grid item sm={12}>
                <Box className={classes.labelAndValue}>
                  <label>Secret Key:</label>
                  {keystore.secretKey}
                </Box>
              </Grid>
            </Grid>
          </Box>
        }
        secondary={
          <Grid container justifyContent="flex-start" spacing={2}>
            <Grid item sm={5}>
              <Grid container direction="column" spacing={1}>
                <Grid item>
                  <Box className={classes.labelAndValue}>
                    <label>Created By:</label>
                    {keystore.createdByUsername}
                  </Box>
                </Grid>
                <Grid item>
                  <Box className={classes.labelAndValue}>
                    <label>Date Created:</label>
                    {keystore.dateCreated}
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item sm={7}>
              <Box className={classes.labelAndValue}>
                <label>Notes:</label>
                <Typography variant="body1">{keystore.notes}</Typography>
              </Box>
            </Grid>
          </Grid>
        }
      />
      <ListItemSecondaryAction classes={{ root: classes.actionContainer }}>
        <Tooltip title="Delete Key Pair">
          <IconButton
            edge="end"
            aria-label="delete"
            onClick={handleDeleteClicked}
            size="large"
          >
            <DeleteIcon fontSize="large" />
            <Typography sx={visuallyHidden}>Edit Account</Typography>
          </IconButton>
        </Tooltip>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default KeystoreListItem;
